import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { SectionNotification } from '.';
import { sectionNotificationDriverFactory } from './SectionNotification.driver';
import { SectionNotificationType } from './types';

const props = {
  icon: <svg>ErrorIcon</svg>,
  text: `You will be redirected to payment provider's page.`,
  type: SectionNotificationType.default,
  buttonTitle: 'Proceed',
};

describe('SectionNotification', () => {
  const createDriver = createRendererWithUniDriver(
    sectionNotificationDriverFactory,
  );

  it('should render', async () => {
    const { driver } = createDriver(
      <SectionNotification>
        <SectionNotification.Text>{props.text}</SectionNotification.Text>
      </SectionNotification>,
    );

    expect(await driver.exists()).toBe(true);
  });

  it('should render notification with content', async () => {
    const { driver } = createDriver(
      <SectionNotification>
        <SectionNotification.Icon icon={props.icon} />
        <SectionNotification.Text>{props.text}</SectionNotification.Text>
        <SectionNotification.Button>
          {props.buttonTitle}
        </SectionNotification.Button>
      </SectionNotification>,
    );

    expect(await driver.getText()).toEqual(props.text);
    expect(await driver.hasButtons()).toBe(true);
    expect(await driver.hasIcon()).toBe(true);
  });

  it('should render notification of type Error', async () => {
    const { driver } = createDriver(
      <SectionNotification type={SectionNotificationType.error}>
        <SectionNotification.Text>{props.text}</SectionNotification.Text>
      </SectionNotification>,
    );

    expect(await driver.isError()).toBe(true);
  });

  it('should render notification of type Alert', async () => {
    const { driver } = createDriver(
      <SectionNotification type={SectionNotificationType.alert}>
        <SectionNotification.Text>{props.text}</SectionNotification.Text>
      </SectionNotification>,
    );

    expect(await driver.isAlert()).toBe(true);
  });

  it('should render notification of type Wired', async () => {
    const { driver } = createDriver(
      <SectionNotification type={SectionNotificationType.wired}>
        <SectionNotification.Text>{props.text}</SectionNotification.Text>
      </SectionNotification>,
    );

    expect(await driver.isWired()).toBe(true);
  });

  it('should render notification of type Success', async () => {
    const { driver } = createDriver(
      <SectionNotification type={SectionNotificationType.success}>
        <SectionNotification.Text>{props.text}</SectionNotification.Text>
      </SectionNotification>,
    );

    expect(await driver.isSuccess()).toBe(true);
  });
});
